import { DiagnosticsService } from "../../../services/diagnostics";

const DTCS = DiagnosticsService.getDtcs();

export default function DiagnosticsPage({ onOpenDtcPage }) {
  const dtcs = DTCS.map((d) => ({
    id: d.id,
    label: `${d.node} DTC ${d.id}`,
    tone: d.severity === "critical" ? "red" : "amber",
    icon: d.severity === "critical" ? "❗" : "⚠️",
  }));

  const pillClass = (tone) => {
    if (tone === "red") return "bg-red-500 text-white";
    if (tone === "amber") return "bg-amber-400 text-slate-900";
    return "bg-slate-600 text-slate-100";
  };

  return (
    <div className="space-y-4">
      <section className="rounded-2xl border border-brand-navy bg-brand-purple p-4">
        <div className="flex items-center justify-between text-sm font-semibold text-brand-light">
          <span>Network Health</span>
        </div>
        <div className="mt-3 grid grid-cols-2 gap-3 text-xs text-brand-light">
          <div className="rounded-xl border border-brand-navy bg-brand-navy px-3 py-3 flex flex-col gap-1">
            <span className="text-brand-light/60">Status</span>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-brand-magenta">
              <span className="h-2 w-2 rounded-full bg-brand-magenta" />
              OK
            </span>
          </div>
          <div className="rounded-xl border border-brand-navy bg-brand-navy px-3 py-3 flex flex-col gap-1 text-right">
            <span className="text-brand-light/60">Nodes Online</span>
            <span className="text-sm font-semibold text-brand-light">5 / 5</span>
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-brand-navy bg-brand-purple p-4 space-y-3">
        <button type="button" onClick={onOpenDtcPage} className="w-full text-left">
          <div className="flex items-center justify-between text-sm font-semibold text-brand-light">
            <span>Active Error Codes (DTCs)</span>
            <span className="text-[13px] text-brand-light/50">›</span>
          </div>
          <div className="space-y-2 mt-3">
            {dtcs.map((item) => (
              <div
                key={item.id}
                className="rounded-xl border border-brand-navy bg-brand-navy px-3 py-2.5 flex items-center gap-3"
              >
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full text-lg ${
                    item.tone === "red"
                      ? "bg-red-900/40 text-red-300 border border-red-500/40"
                      : "bg-amber-900/30 text-amber-300 border border-amber-500/40"
                  }`}
                >
                  {item.icon}
                </span>
                <span className="text-sm font-semibold text-brand-light flex-1">{item.label}</span>
                <span className={`text-[10px] font-semibold px-2 py-1 rounded-full ${pillClass(item.tone)}`}>
                  {item.tone === "red" ? "Critical" : "Warning"}
                </span>
              </div>
            ))}
          </div>
        </button>
      </section>

      <section className="rounded-2xl border border-brand-navy bg-brand-purple p-4 space-y-2">
        <div className="flex items-center justify-between text-sm font-semibold text-brand-light">
          <span>Advanced Tools</span>
        </div>
        {[
          { label: "CAN Bus Monitor", icon: "📄" },
          { label: "Remote Diagnostics", icon: "🔄" },
        ].map((item) => (
          <button
            key={item.label}
            type="button"
            className="w-full rounded-xl border border-brand-navy bg-brand-navy px-3 py-3 flex items-center justify-between text-sm text-brand-light hover:border-brand-magenta/60 transition"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-purple text-brand-magenta text-base">
                {item.icon}
              </span>
              <span className="font-semibold">{item.label}</span>
            </div>
            <span className="text-lg text-brand-light/50">›</span>
          </button>
        ))}
      </section>
    </div>
  );
}
